import {UserComponentManager} from './UserComponentManager';
import * as pc from 'playcanvas';
import {noise} from './../../noise';
import gsap from 'gsap';
import {CreatureManager} from '../CreatureManager';

const Component_Slither = UserComponentManager.createComponent('slither');

Component_Slither.getParams = function() {
  return {
    slither_counter: 0,
    rateOfTravel: 0.001,
    noise_slitherRate: {origin: 4, counter: 0, rate: 0.5, range: 2},
    noise_lean: {origin: 0.5, counter: 0, rate: 0.5, range: 0.5},
    glb: {},
    minX: -1,
    maxX: 1,
    despawning: false,
    entityScaleX: 0,
    entityScale: 0,
    laneIndex: 0,
    morphInstance: {},
  };
};
Component_Slither.attachToEntity = function(name, entity, glb, laneIndex, configObj) {
  const p = Component_Slither.getParams();
  p.name = name;
  p.entity = entity;
  p.laneIndex = laneIndex;
  const facingRight = laneIndex === 0;
  // tailored vars based on travelling left or right
  if (facingRight) {
    p.rateOfTravel = configObj.rateOfTravel;
    p.minX = -CreatureManager.slither_spawnOrigin_max;
    p.maxX = CreatureManager.slitherLimitX;
  } else {
    p.rateOfTravel = -configObj.rateOfTravel;
    p.minX = -CreatureManager.slitherLimitX;
    p.maxX = CreatureManager.slither_spawnOrigin_max;
  }

  p.glb = glb;
  p.slitherMorphs = [];
  glb.render.meshInstances.forEach((mi) => {
    p.slitherMorphs.push(mi.morphInstance);
  });
  p.slither_counter = Math.floor(Math.random() * 1000);
  p.morphInstance = glb.render.meshInstances[0].morphInstance;

  // slither vars from configObj
  p.noise_slitherRate.origin = configObj.slitherOrigin;
  p.noise_slitherRate.rate = configObj.slitherRate;
  p.noise_slitherRate.range = configObj.slitherRange;
  p.noise_lean.rate = configObj.leanRate;

  this.active[name] = p;
  this.scaleIn(p);

  return p;
};
Component_Slither.do = function(obj, dt) {
  // update slither noise (determins rate of undulation)
  const slitherRate = this.tickNoise(obj.noise_slitherRate, dt);
  obj.slither_counter += (dt * slitherRate);
  const slitherValue = 0.5 + Math.sin(obj.slither_counter) * 0.5;
  obj.slitherMorphs.forEach((m) => {
    m.setWeight(0, slitherValue);
  });
  obj.morphInstance.setWeight(1, this.tickNoise(obj.noise_lean, dt));

  const distanceTravelled = (obj.rateOfTravel * slitherRate) * (pc.math.clamp((slitherValue - 0.5), 0, 0.5) / 0.5);
  const cPos = obj.entity.getLocalPosition();
  const newX = cPos.x + distanceTravelled;
  obj.entity.setLocalPosition(newX, cPos.y, cPos.z);

  if (!obj.despawning) {
    if (newX < obj.minX || newX > obj.maxX) {
      Component_Slither.scaleOut(obj);
    }
  }
};
Component_Slither.tickNoise = function(noiseObj, dt) {
  noiseObj.counter += dt * noiseObj.rate;
  const n = noise.simplex2(noiseObj.counter, 0) * (noiseObj.range);
  return noiseObj.origin + n;
};
Component_Slither.scaleIn = function(obj) {
  gsap.to(obj, {
    entityScale: 1,
    duration: 6,
    ease: 'back.out(2)',
    onUpdate: () => {
      obj.entity.setLocalScale(obj.entityScaleX, obj.entityScale, 1);
    },
  });
  gsap.to(obj, {
    entityScaleX: obj.laneIndex === 0 ? 1 : -1,
    duration: 6,
    ease: 'back.out(2)',
    onUpdate: () => {
      obj.entity.setLocalScale(obj.entityScaleX, obj.entityScale, 1);
    },
  });
};
Component_Slither.scaleOut = function(obj) {
  obj.despawning = true;
  gsap.to(obj, {
    entityScale: 0,
    duration: 6,
    ease: 'strong.in',
    onUpdate: () => {
      obj.entity.setLocalScale(obj.entityScaleX, obj.entityScale, 1);
    },
    onComplete: () => {
      Component_Slither.despawn(obj);
    },
  });
  gsap.to(obj, {
    entityScaleX: 0,
    duration: 6,
    ease: 'strong.in',
    onUpdate: () => {
      obj.entity.setLocalScale(obj.entityScaleX, obj.entityScale, 1);
    },
  });
};
Component_Slither.despawn = function(obj) {
  const laneIndex = obj.laneIndex;

  delete this.active[obj.name];
  obj.entity.destroy;
  obj = null;
  CreatureManager.addRandomSlitherer(laneIndex);
};
Component_Slither.flush = function() {
  for (const key in this.active) {
    if (Object.hasOwnProperty.call(this.active, key)) {
      let obj = this.active[key];
      obj.entity.destroy();
      delete this.active[obj.name];
      obj = null;
    }
  }
  this.active = {};
};


export {Component_Slither};
